var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMultibetoftheday = function SvgMultibetoftheday(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.318,
    height: 16.58,
    viewBox: "0 0 17.318 16.58",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_multibetoftheday",
    transform: "translate(0 2.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M1174.4,498.51h-8.054a1.95,1.95,0,0,1-1.947-1.948v-11.1a1.95,1.95,0,0,1,1.947-1.948h5.478c.634.012.541.966,0,.966h-5.478a.982.982,0,0,0-.981.982v11.1a.983.983,0,0,0,.981.982h8.054a.983.983,0,0,0,.981-.982V494.8a.483.483,0,0,1,.966,0v1.758A1.95,1.95,0,0,1,1174.4,498.51Z",
    transform: "translate(-1164.394 -483.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M1172.035,490.812h-3.369a.483.483,0,0,1,0-.966h3.369a.483.483,0,1,1,0,.966Z",
    transform: "translate(-1166.353 -487.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M1171.855,496.36h-3.189a.483.483,0,0,1,0-.966h3.189a.483.483,0,0,1,0,.966Z",
    transform: "translate(-1166.353 -490.133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M1171.91,501.906h-3.244a.483.483,0,0,1,0-.966h3.244a.483.483,0,1,1,0,.966Z",
    transform: "translate(-1166.353 -493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M1170.96,507.453h-2.294a.483.483,0,0,1,0-.966h2.294a.483.483,0,0,1,0,.966Z",
    transform: "translate(-1166.353 -495.867)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_arrow_up",
    transform: "translate(7.006 -2.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42806",
    "data-name": "Path 42806",
    d: "M11160.111,758.1h-2.91l5.2-6.072,5.111,6.072h-3.035v2.453h-4.367Z",
    transform: "translate(-11157.201 -752.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42807",
    "data-name": "Path 42807",
    d: "M0,0H4.362V.843H0Z",
    transform: "translate(2.919 9.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42808",
    "data-name": "Path 42808",
    d: "M0,0H4.362V.843H0Z",
    transform: "translate(2.919 10.639)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMultibetoftheday, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };